// extracted by mini-css-extract-plugin
export default {"main":"ReporteEmbarques_main__fG4fa"};